import gql from 'graphql-tag'

export const CREATE_CONTACT_MUTATION = gql`
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) @rest(type: "Contact", path: "contacts", method: "POST") {
      uuid
    }
  }
`
